import { render, staticRenderFns } from "./ContentVideo.vue?vue&type=template&id=29b77e38&scoped=true&"
import script from "./ContentVideo.vue?vue&type=script&lang=js&"
export * from "./ContentVideo.vue?vue&type=script&lang=js&"
import style0 from "./ContentVideo.vue?vue&type=style&index=0&id=29b77e38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b77e38",
  null
  
)

export default component.exports